import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NbAlertModule, NbButtonModule, NbCheckboxModule, NbFormFieldModule, NbIconModule, NbInputModule, NbMenuModule, NbSelectModule, NbSpinnerModule } from '@nebular/theme';
import { ThemeModule } from '../../@theme/theme.module';
import { ChangePswComponent } from './change-psw/change-psw.component';
import { LoginComponent } from './login/login.component';
import { ResetPswComponent } from './reset-psw/reset-psw.component';
import { RegisterComponent } from './register/register.component';
import { RouterModule } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';

@NgModule({
  imports: [
    NbMenuModule,
    ThemeModule,
    NbInputModule,
    NbFormFieldModule,
    NbIconModule,
    FormsModule,
    NbAlertModule,
    CommonModule,
    NbButtonModule,
    RouterModule,
    NbCheckboxModule,
    NbSelectModule,
    NbSpinnerModule,
  ],
  declarations: [
    LoginComponent,
    ChangePswComponent,
    ResetPswComponent,
    RegisterComponent,
    WelcomeComponent,
  ],
})
export class AuthModule {
}
